export const NETWORK_RPC_URLS: { [key: number]: string[] } = {
  250: ['https://rpc.fantom.network', 'https://1rpc.io/ftm', 'https://fantom-mainnet.public.blastapi.io'],
  // 250: 'https://rpc.fantom.network',
  43114: ['https://api.avax.network/ext/bc/C/rpc'],
  137: ['https://polygon-rpc.com/'],
  8453: ['https://mainnet.base.org'],
  324: ['https://mainnet.era.zksync.io'],
  146: ['rpc.sonicscan.org']
};
